import { kpHistory } from '../common/router/history';
import { ERegionBasic, TyRegion } from '../types';
import { safeGet } from './objectUtils';

// export const REGION_MAP: Record<TyRegion, string> = {
//   'NORTHERN-CALIFORNIA': ERegionBasic.NCAL,
//   'SOUTHERN-CALIFORNIA': ERegionBasic.SCAL
// };

export const REGION_MAP: Record<TyRegion, string> = {
  'NORTHERN-CALIFORNIA': ERegionBasic.NCAL,
  'SOUTHERN-CALIFORNIA': ERegionBasic.SCAL
};
/**
 * Finds the key for a given value in a record.
 *
 * @param {ERegionBasic} value - The value to find.
 * @returns {string | undefined} - The key if found, otherwise undefined.
 */
export const getRegionUriFromRegionMap = (value: string | ERegionBasic): string | undefined => {
  return Object.keys(REGION_MAP).find(key => REGION_MAP[key as TyRegion].toLowerCase() === value?.toLowerCase())?.toLowerCase();
};

export const getRegionFromUri = () => {
  return kpHistory.location.pathname.split('/')[1];
};

export const getRegionFromPath = (): string => {
  return window.location.pathname.split('/')[1];
}

export const getKPRegion = () => {
  return REGION_MAP[getRegionFromPath().toUpperCase() as TyRegion];
};

export const getUserRegion = (region: string | undefined) => {
  if (!region) return '';
  region = region.toUpperCase();
  let userRegion = region;
  if (region.toLowerCase() === 'scal' || REGION_MAP[region.toUpperCase() as TyRegion]?.toLowerCase() === 'scal') {
    userRegion = ERegionBasic.SCAL;
  }

  if (region.toLowerCase() === 'ncal' || REGION_MAP[region.toUpperCase() as TyRegion]?.toLowerCase() === 'ncal') {
    userRegion = ERegionBasic.NCAL;
  }
  return userRegion as ERegionBasic;
};

export const getRegionForConfig = (region?: any) => {
  const lowerCaseRegion = region?.toLowerCase();
  if (lowerCaseRegion === 'nat') {
    return 'nat'
  }
  else return getKPRegion()?.toLowerCase()
}


export const getRegionsFromHeaderContent = (content: any) => {
  let regions: any;
  safeGet(content, 'header.top_navigation_toolbar', []).map((item: any, index: any) => {
    if (item.hasOwnProperty('region_picker'))
      regions = safeGet(item, 'region_picker.kp_regions.regions.value', []);
  })
  return regions || [];
}
